<p>test works!</p>
<div>mode: {{mode|json}}</div>
<div *ngIf="jobs?.length">
  <h6>jobs</h6>
  <ng-container *ngFor="let job of jobs" [ngSwitch]="mode">
    <h6 *ngSwitchCase="'api'">{{job.Title}}</h6>
    <app-job-summary *ngSwitchCase="'summary'" [job]="job"></app-job-summary>
  </ng-container>
</div>
